module.exports = __webpack_public_path__ + "static/media/en.6974ed82.png";